import { styled, Theme } from '@mui/material';

import { Typography } from '@/shared/ui';

export const Description = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
}));

export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '0px 60px',
  },
  divider: (theme: Theme) => ({
    my: 1,
    backgroundColor: theme.palette.custom.grey6,
  }),
  textContainer: {
    maxWidth: '80%',
  },
};
